// client/src/components/marketer/MarketerHomeHeader.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { clearMarketerCache } from '../../utils/marketerProjectCache';
import { clearResultCache } from '../../utils/marketerResultCache';
import { clearCPSCache } from '../../utils/marketerCPSCache';
import { usePoints } from '../../contexts/PointContext';
const API_URL = process.env.REACT_APP_API_URL;

function MarketerHomeHeader() {
	const nav = useNavigate();
	const { points, loading, isRefreshing } = usePoints();

	const goHome = () => nav('/marketer/mybiz');
	const goGuide = () => window.open('/guide', '_blank', 'noopener,noreferrer');
	const prefetchNotices = () => {
		fetch(`${API_URL}/api/notices?page=1&pageSize=15`, { credentials: 'include' })
			.then(r => r.json()).then(j => { if (j?.ok) localStorage.setItem('notice_p1', JSON.stringify(j)); })
			.catch(()=>{});
	};
  const goNotice = () => { try { sessionStorage.setItem('current_user_role', 'marketer'); } catch {} prefetchNotices(); nav('/notice', { state: { role: 'marketer' } }); }
	const goInquiry = () => nav('/inquiry', { state: { role: 'marketer' } });
	const goMybiz = () => nav('/marketer/mybiz', { state: { role: 'marketer' } });

	// 공개 진입점 (로그인 후에도 노출) — 추후 LP nav 스타일로 통합 예정
	const goMarketerLp = () => nav('/lp/marketer');
	const goInfluencerLp = () => nav('/lp/influencer');
	const goFaq = () => nav('/faq'); 

	const logout = async () => {
		try {
			await fetch(`${API_URL}/api/user/logout`, { method: 'POST', credentials: 'include' });
		} catch {}
		
		// ✅ 1. 캐시 초기화 (window.__ME__ 삭제 전에!)
		const uid = window.__ME__?.id;
		clearMarketerCache(uid);
		clearResultCache(uid);
		clearCPSCache(uid);
		
		// ✅ 2. sessionStorage 완전 초기화
		try {
			const keys = Object.keys(sessionStorage);
			keys.forEach(key => {
				if (key.startsWith('MARKETER_PROJECT_') || 
				    key.startsWith('MARKETER_RESULT_') ||
				    key.startsWith('MARKETER_CPS_') ||
				    key.startsWith('INF_') ||
				    key.startsWith('user_points_cache_') ||
				    key.startsWith('mrk_') ||
				    key === 'current_user_key' || 
				    key === 'current_user_role') {
					sessionStorage.removeItem(key);
				}
			});
		} catch {}
		
		// ✅ 3. localStorage 광고주 관련 캐시 초기화
		try {
			const lsKeys = Object.keys(localStorage);
			lsKeys.forEach(key => {
				if (key.startsWith('mrk_') || key.startsWith('marketer_')) {
					localStorage.removeItem(key);
				}
			});
		} catch {}
		
		// ✅ 4. window.__ME__ 완전히 삭제
		if (window.__ME__) {
			delete window.__ME__;
		}
		
		// ✅ 5. 페이지 새로고침으로 완전 초기화
		window.location.href = '/';
	};

	return (
		<header className="marketer-header">
			<div className="marketer-header__left">
				<button className="marketer-header__logo-button" onClick={goHome} aria-label="광고주 홈으로">
					<img 
						src="/images/logo.svg" 
						alt="셀프애드" 
						className="marketer-header__logo"
					/>
				</button>
			<button className="marketer-header__nav-button" onClick={goMarketerLp}>광고주 안내</button>
				<button className="marketer-header__nav-button" onClick={goGuide}>서비스 가이드</button>
				<button className="marketer-header__nav-button" onClick={goNotice}>공지사항</button>
				<button className="marketer-header__nav-button" onClick={goFaq}>FAQ</button>
				<button className="marketer-header__nav-button" onClick={goInquiry}>문의하기</button>
				<button className="marketer-header__nav-button" onClick={goMybiz}>마이비즈</button>
			</div>
			
		<div className="marketer-header__right">
			{/* 포인트 표시 */}
			<div className={`marketer-header__points ${loading ? 'marketer-header__points--loading' : ''} ${isRefreshing ? 'marketer-header__points--refreshing' : ''}`}>
				💰 {loading ? '...' : points.toLocaleString()}pt
			</div>
			
			<button className="marketer-header__logout" onClick={logout}>로그아웃</button>
		</div>
		</header>
	);
}

export default MarketerHomeHeader;